import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { SOLUTION_CATEGORIES } from '../data/homeMenus';

export const CapitalLifecycle = () => {
  return (
    <section id="capital-solutions" className="py-24 bg-slate-50" data-testid="capital-lifecycle">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="heading-2 text-slate-900 mb-4">
            Capital Solutions Across the <span className="text-emerald-600">Business Lifecycle</span>
          </h2>
          <p className="body-normal text-slate-600">
            Every capital solution in our advisory practice — structured, compared and placed with the right lender
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-7xl mx-auto">
          {SOLUTION_CATEGORIES.map((cat) => (
            <Link
              key={cat.slug}
              to={`/solutions/${cat.slug}`}
              className="group relative overflow-hidden bg-white rounded-xl border border-slate-200 hover:border-emerald-500 hover:shadow-[0_4px_16px_rgba(15,23,42,0.08)] hover:-translate-y-1 transition-all duration-300 h-56 flex flex-col justify-end"
              data-testid={`lifecycle-${cat.slug}`}
            >
              {/* Subtle category imagery */}
              <img
                src={`/img/solutions/${cat.slug}.webp`}
                alt=""
                loading="lazy"
                decoding="async"
                className="absolute inset-0 w-full h-full object-cover opacity-30 group-hover:opacity-40 group-hover:scale-[1.03] transition-all duration-500 blur-sm"
                style={{ filter: 'blur(4px)' }}
                aria-hidden="true"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-white via-white/60 to-white/10"></div>

              {/* Category name */}
              <div className="relative p-6">
                <div className="w-8 h-0.5 bg-emerald-500 mb-3"></div>
                <h3 className="heading-4 text-slate-900 leading-snug group-hover:text-emerald-700 transition-colors">
                  {cat.name}
                </h3>
                <span className="mt-2 inline-flex items-center gap-1.5 text-sm font-semibold text-emerald-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  Explore <ArrowRight className="w-4 h-4" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};
